document.querySelectorAll('.index-object-testimonials-slider').forEach(el => {
    if (!el.classList.contains('swiper-initialized')) {
        new Swiper(el, {
            loop: false,
            grabCursor: false,
            spaceBetween: 16,
            slidesPerGroup: 1,
            slidesPerView: "auto",
            watchSlidesProgress: true,
            autoHeight: false,
            watchOverflow: true,
            threshold: 10,
            mousewheel: {
                forceToAxis: !0
            },
            observer: true,
            observeParents: true,
            freeMode: true,
            breakpoints: {
                0: {
                    freeMode: false
                },
                750: {
                },
                990: {
                },
                1200: {
                },
                1440: {
                }
            }
        })
    }
});


/* GET ALL TESTIMONIALS SECTIONS */
const testimonialsSections = document.querySelectorAll(".testimonials");

/* MUTE A SINGLE VIDEO ITEM */
function muteVideoItem(item) {

  if (!item) return;

  const video     = item.querySelector('video');
  const muteBtn   = item.querySelector('.mute_video');
  const unmuteBtn = item.querySelector('.unmute_video');

  if (!video || !muteBtn || !unmuteBtn) return;

  video.muted = true;
  muteBtn.classList.remove('active');
  unmuteBtn.classList.add('active');

  // optional: also pause when out of view
  // video.pause();

}

/* MUTE ALL VIDEOS WITHIN A GIVEN SECTION (kept for potential reuse) */
function muteAllVideos(section) {

  if (!section) return;

  const list = section.querySelector(".video_play_list");
  if (!list) return;

  list.querySelectorAll(".full_video_new").forEach(function (item) {
    muteVideoItem(item);
  });

}

/* VIDEO BUTTON CONTROLS (EVENT DELEGATION) — PER SECTION */
testimonialsSections.forEach(function (section) {

  const playlist = section.querySelector(".video_play_list");
  if (!playlist) return;

  playlist.addEventListener("click", function (e) {

    const muteBtn = e.target.closest(".mute_video");
    const unmuteBtn = e.target.closest(".unmute_video");

    if (!muteBtn && !unmuteBtn) return;

    const parent = e.target.closest(".full_video_new");
    const video = parent.querySelector("video");
    const mute = parent.querySelector(".mute_video");
    const unmute = parent.querySelector(".unmute_video");

    /* MUTE BUTTON */
    if (muteBtn) {

      video.muted = true;

      mute.classList.remove("active");
      unmute.classList.add("active");

    }

    /* UNMUTE BUTTON */
    if (unmuteBtn) {

      const wasPlaying = !video.paused;

      /* MUTE OTHER VIDEOS ONLY (WITHIN THIS SECTION'S PLAYLIST) */
      playlist.querySelectorAll("video").forEach(function (v) {
        if (v !== video) v.muted = true;
      });

      playlist.querySelectorAll(".full_video_new").forEach(function (item) {

        if (item !== parent) {

          item.querySelector(".mute_video").classList.remove("active");
          item.querySelector(".unmute_video").classList.add("active");

        }

      });

      video.muted = false;

      unmute.classList.remove("active");
      mute.classList.add("active");

      /* SAFARI STABILITY FIX */
      if (wasPlaying) video.play();

    }

  });

});

/* MUTE EACH VIDEO WHEN IT INDIVIDUALLY LEAVES THE VIEWPORT */
if (testimonialsSections.length) {

  const videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          muteVideoItem(entry.target);
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px",
    }
  );

  testimonialsSections.forEach(function (section) {

    const list = section.querySelector(".video_play_list");
    if (!list) return;

    list.querySelectorAll(".full_video_new").forEach(function (item) {
      videoObserver.observe(item);
    });

  });

}
/* Video List End */